import React, { useEffect, useState } from 'react'
import { Badge, Button, Dropdown, Menu } from 'antd'
import { NotificationIcon } from 'config/icons'
import { FormattedMessage } from 'react-intl'
import styles from './style.module.scss'
import { getNotificationsCounter, getNotificationsList } from '../../../../../services/api'

const RightActions = () => {
  const [notificationCount, setNotificationCount] = useState(0)
  const [notificationsList, setNotificationsList] = useState([])

  useEffect(() => {
    getNotificationsCounter().then(response => {
      setNotificationCount(response.data.counter)
    })
  }, [])
  useEffect(() => {
    getNotificationsList().then(response => {
      setNotificationsList(response.data.notifiche)
    })
  }, [])

  const menu = (
    <React.Fragment>
      <div style={{ marginTop: -14, width: 300, marginRight: -80 }}>
        <div className={styles.arrowUp} />
        <Menu
          selectable={false}
          style={{
            borderRadius: 6,
            boxShadow: '0px 6px 12px #00000052',
          }}
        >
          <Menu.Item
            key={'header'}
            style={{
              backgroundColor: '#014F86',
              borderRadius: '6px 6px 0px 0px',
              marginTop: '-5px'
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'Space-between' }}>
              <strong style={{ color: 'white' }}>
                <FormattedMessage id={'global.notifiche'} />
              </strong>
              <Button style={{ color: 'white', background: 'transparent' }}>
                <FormattedMessage id={'global.cancel_all'} />
              </Button>
            </div>
          </Menu.Item>
          {notificationCount > 0 &&
            notificationsList.map(item => {
              return (
                <Menu.Item key={item.id}>
                  <a
                    href={`#${item.object_type === 'curriculum' ? '/candidates' : ''}/${
                      item.object_id
                    }`}
                  >
                    <span className={styles.menuOption}>{item.subject}</span>
                  </a>
                </Menu.Item>
              )
            })}
          {notificationCount > 0 ? (
            <Menu.Item key={'footer'}>
              <a href={'#'}>
                <span className={styles.menuOption} style={{ fontStyle: 'italic' }}>
                  <FormattedMessage id="global.view_all_notifications" />
                </span>
              </a>
            </Menu.Item>
          ) : (
            <Menu.Item key={'footer'}>
              <span className={styles.menuOption} style={{ fontStyle: 'italic' }}>
                <FormattedMessage id="global.no_notifications" />
              </span>
            </Menu.Item>
          )}
        </Menu>
      </div>
    </React.Fragment>
  )
  return (
    <Dropdown overlay={menu} trigger={['click']} placement="bottomRight">
      <div className={styles.dropdown}>
        <Badge count={notificationCount}>
          <NotificationIcon className={styles.icon} />
        </Badge>
      </div>
    </Dropdown>
  )
}

export default RightActions
